import en from './client.en.json';
const trans = {
    Trans: en
};
export default trans;